@if (loadError) {
  <div class="modal-body">
    <div class="alert alert-danger mb-0" role="alert" data-cy="policyLoadError">
      <i class="fal fa-triangle-exclamation me-1" aria-hidden="true"></i>
      The data policies could not be loaded. You can still save the field, and its data policy permissions will not change.
    </div>
  </div>
} @else if (policiesLoaded) {
  <div class="modal-body">
    @if (!policies?.length) {
      <div class="alert alert-info mb-0" role="status" data-cy="noDataPolicies">
        There are no data policies in this division.
      </div>
    } @else {
      <div class="d-flex flex-column policies-grid scroll-vert" [class.policies-grid--readonly]="isReadOnly" role="table"
        aria-label="Template field data policies">
        <div class="d-flex policies-grid__row policies-grid__row--heading policies-grid__row--sticky" role="row"
          data-cy="policyGridHeading">
          @for (securityRight of securityRights; track securityRight.rightFlag) {
            <div class="policies-grid__col policies-grid__col--narrow text-uppercase" role="columnheader"
              data-cy="policyRightHeading">{{ securityRight.name }}</div>
          }
          <div class="policies-grid__col flex-fill" role="columnheader">Data Policy</div>
        </div>
        <div class="d-flex policies-grid__row policies-grid__row--sub-heading policies-grid__row--sticky policies-grid__row--bulk"
          role="row" data-cy="policyGridBulkRow">
          @for (securityRight of securityRights; track securityRight.rightFlag) {
            <div class="policies-grid__col policies-grid__col--narrow d-flex justify-content-stretch p-0" role="cell">
              <div class="success permissions-sm text-center" role="button" [title]="'Allow All ' + securityRight.name"
                [attr.aria-label]="'Allow All ' + securityRight.name" [attr.aria-disabled]="isReadOnly"
                [attr.tabindex]="isReadOnly ? -1 : 0" (click)="setAll($event, securityRight.rightFlag, statusKey.allow)"
                (keydown.enter)="setAll($event, securityRight.rightFlag, statusKey.allow)"
                (keydown.space)="setAll($event, securityRight.rightFlag, statusKey.allow)" data-cy="allowAll">
                <i class="fal fa-circle-check" aria-hidden="true"></i>
              </div>
              <div class="danger permissions-sm border-start border-end text-center" role="button"
                [title]="'Deny All ' + securityRight.name" [attr.aria-label]="'Deny All ' + securityRight.name"
                [attr.aria-disabled]="isReadOnly" [attr.tabindex]="isReadOnly ? -1 : 0"
                (click)="setAll($event, securityRight.rightFlag, statusKey.deny)"
                (keydown.enter)="setAll($event, securityRight.rightFlag, statusKey.deny)"
                (keydown.space)="setAll($event, securityRight.rightFlag, statusKey.deny)" data-cy="denyAll">
                <i class="fal fa-circle-xmark" aria-hidden="true"></i>
              </div>
              <div class="effective-neutral permissions-sm text-center" role="button"
                [title]="'Set All ' + securityRight.name + ' Neutral'"
                [attr.aria-label]="'Set All ' + securityRight.name + ' Neutral'" [attr.aria-disabled]="isReadOnly"
                [attr.tabindex]="isReadOnly ? -1 : 0" (click)="setAll($event, securityRight.rightFlag, statusKey.neutral)"
                (keydown.enter)="setAll($event, securityRight.rightFlag, statusKey.neutral)"
                (keydown.space)="setAll($event, securityRight.rightFlag, statusKey.neutral)" data-cy="allNeutral">
                <i class="fal fa-circle" aria-hidden="true"></i>
              </div>
            </div>
          }
          <div class="policies-grid__col flex-fill" role="cell"></div>
        </div>
        @for (policy of policies; track policy.securityPolicyID) {
          <div class="d-flex policies-grid__row policies-grid__row--sub-heading" role="row" data-cy="policyRow">
            @for (securityRight of securityRights; track securityRight.rightFlag) {
              <div class="policies-grid__col policies-grid__col--narrow" role="cell" [title]="securityRight.name"
                [ngClass]="effectiveClass[policy.securityPolicyID]?.[securityRight.rightFlag]" data-cy="policyCell">
                <rl-security-policy-cell [rightFlag]="securityRight.rightFlag" [description]="securityRight.name"
                  [rightStatuses]="rightStatus[policy.securityPolicyID]" [readonly]="isReadOnly"
                  (onChange)="toggle(policy, securityRight.rightFlag)">
                </rl-security-policy-cell>
              </div>
            }
            <div class="policies-grid__col flex-fill" role="cell">
              <a [routerLink]="['/administration/policy', policy.securityPolicyID]" target="_blank" rel="noopener"
                [title]="'Open ' + policy.policyTitle + ' in a new tab'" data-cy="policyLink">{{ policy.policyTitle }}</a>
            </div>
          </div>
        }
      </div>
      <button type="button" class="btn btn-link btn-sm p-1 mt-2" [disabled]="isReadOnly" (click)="resetPolicyChanges()"
        data-cy="resetPolicyChanges">Reset Policy Changes</button>
    }
  </div>
} @else {
  <div class="p-4 text-center" aria-busy="true">
    <rl-loader></rl-loader>
  </div>
}
